module.exports = __webpack_public_path__ + "static/oop_overall-9287080b226859a78406bd7f2c6bd5e7.png";